"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DateParameter',
  props: {
    mode: {
      type: String,
      default: 'hotel',
      validator: function validator(val) {
        return ['hotel', 'appointment'].includes(val);
      }
    },
    stockWarning: {
      type: [Number, String],
      default: 0
    },
    storeId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    var _this = this;
    return {
      form: {
        hotelCheckInTime: '14:00',
        hotelCheckOutTime: '12:00',
        deadlineTime: '22:00',
        customerCancelDays: '',
        customerCancelTime: '22:00',
        refundDays: '',
        refundTime: '00:00',
        timeoutAutoRefundFlag: 1,
        dateRange: null,
        price: '',
        costPrice: '',
        stock: 0,
        minQuantity: 1,
        maxQuantity: 9999,
        attrValue: [],
        // 酒店退款配置
        hotelRefundConfigs: [],
        cancelLimitHour: 24,
        // 保存于 hotelExtra，用于区分店铺同步规则和商品自定义规则
        syncStoreRefundConfig: 1
      },
      currentDate: new Date(),
      // 当前显示的月份
      editablePrices: {},
      // 日历内联编辑的价格缓存
      editableCostPrices: {},
      // 日历内联编辑的成本价缓存
      isInitializing: false,
      // 标记是否正在初始化（编辑模式回显数据）
      refundConfigVersion: 0,
      // 防止店铺配置异步响应覆盖商品详情回填
      rangeDialogVisible: false,
      dayDialogVisible: false,
      dayForm: {
        idx: -1,
        expireDate: '',
        weekDay: '',
        price: '',
        costPrice: '',
        stock: ''
      },
      dayFormRules: {
        price: [{
          required: true,
          message: '请输入价格',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入有效的价格',
          trigger: 'blur'
        }],
        costPrice: [{
          required: true,
          message: '请输入成本价',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入有效的成本价',
          trigger: 'blur'
        }],
        stock: [{
          required: true,
          message: '请输入库存',
          trigger: 'blur'
        }, {
          pattern: /^\d+$/,
          message: '请输入有效的库存数量',
          trigger: 'blur'
        }]
      },
      rangeForm: {
        dateRange: [],
        basePrice: '',
        baseCostPrice: '',
        baseStock: ''
      },
      rangeItems: [],
      weekdayHeaders: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      hotelRules: {
        hotelCheckInTime: [{
          required: true,
          message: '请输入入店时间',
          trigger: 'change'
        }],
        hotelCheckOutTime: [{
          required: true,
          message: '请输入离店时间',
          trigger: 'change'
        }],
        deadlineTime: [{
          required: true,
          message: '请输入当日预订截止时间',
          trigger: 'change'
        }],
        customerCancelDays: [{
          required: true,
          message: '请输入客户可取消天数',
          trigger: 'blur'
        }, {
          pattern: /^\d+$/,
          message: '请输入有效的天数',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (!_this.form.customerCancelTime) {
              callback(new Error('请选择客户可取消时间'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
        dateRange: [{
          required: true,
          message: '请选择日期范围',
          trigger: 'change'
        }],
        price: [{
          required: true,
          message: '请输入单价',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入有效的价格',
          trigger: 'blur'
        }],
        costPrice: [{
          required: true,
          message: '请输入成本价',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入有效的成本价',
          trigger: 'blur'
        }],
        stock: [{
          required: true,
          message: '请输入每天库存',
          trigger: 'blur'
        }, {
          pattern: /^\d+$/,
          message: '请输入有效的库存数量',
          trigger: 'blur'
        }]
      },
      appointmentRules: {
        deadlineTime: [{
          required: true,
          message: '请选择当日预订截止时间',
          trigger: 'change'
        }],
        refundDays: [{
          required: true,
          message: '请输入可退款天数',
          trigger: 'blur'
        }, {
          pattern: /^\d+$/,
          message: '请输入有效的天数',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (!_this.form.refundTime) {
              callback(new Error('请选择可退款时间'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
        refundTime: [{
          required: true,
          message: '请选择可退款时间',
          trigger: 'change'
        }],
        timeoutAutoRefundFlag: [{
          required: true,
          message: '请选择是否自动退',
          trigger: 'change'
        }],
        dateRange: [{
          required: true,
          message: '请选择日期范围',
          trigger: 'change'
        }],
        price: [{
          required: true,
          message: '请输入单价',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入有效的价格',
          trigger: 'blur'
        }],
        costPrice: [{
          required: true,
          message: '请输入成本价',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入有效的成本价',
          trigger: 'blur'
        }],
        stock: [{
          required: true,
          message: '请输入每天库存',
          trigger: 'blur'
        }, {
          pattern: /^\d+$/,
          message: '请输入有效的库存数量',
          trigger: 'blur'
        }],
        minQuantity: [{
          required: true,
          message: '请输入起购数量',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '请输入有效的起购数量',
          trigger: 'blur'
        }],
        maxQuantity: [{
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback();
              return;
            }
            if (!/^[1-9]\d*$/.test(String(value))) {
              callback(new Error('请输入有效的限购数量'));
              return;
            }
            var minQuantity = Number(_this.form.minQuantity);
            if (!Number.isNaN(minQuantity) && Number(value) < minQuantity) {
              callback(new Error('限购数量不能小于起购数量'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    localStockWarning: {
      get: function get() {
        return this.stockWarning;
      },
      set: function set(val) {
        this.$emit('update:stockWarning', val);
      }
    },
    // 酒店退款配置默认行
    defaultHotelRefundConfigs: function defaultHotelRefundConfigs() {
      return [{
        startHour: 96,
        endHour: null,
        refundRate: 100,
        disabled: true
      }, {
        startHour: 72,
        endHour: 96,
        refundRate: 70,
        disabled: false
      }, {
        startHour: 48,
        endHour: 72,
        refundRate: 50,
        disabled: false
      }, {
        startHour: 24,
        endHour: 48,
        refundRate: 20,
        disabled: false
      }];
    },
    hotelRefundCancelLimitHour: function hotelRefundCancelLimitHour() {
      var list = this.form.hotelRefundConfigs || [];
      var lastItem = list[list.length - 1];
      return lastItem && Number(lastItem.startHour) > 0 ? Number(lastItem.startHour) : 0;
    },
    canOpenRangePrice: function canOpenRangePrice() {
      return this.form.dateRange && this.form.dateRange.length === 2;
    },
    rangeSummary: function rangeSummary() {
      if (!this.form.dateRange || this.form.dateRange.length !== 2) return '';
      var _this$form$dateRange = _slicedToArray(this.form.dateRange, 2),
        start = _this$form$dateRange[0],
        end = _this$form$dateRange[1];
      var days = this.getDatesInRange(start, end).length;
      return "".concat(start, " \u81F3 ").concat(end, "\uFF0C\u5171 ").concat(days, " \u5929");
    },
    datePickerOptions: function datePickerOptions() {
      var min = new Date();
      min.setHours(0, 0, 0, 0);
      var max = new Date();
      max.setHours(0, 0, 0, 0);
      max.setFullYear(max.getFullYear() + 5);
      return {
        disabledDate: function disabledDate(date) {
          return date < min || date > max;
        }
      };
    },
    rangeDialogPickerOptions: function rangeDialogPickerOptions() {
      // 限制在主日期范围内选择
      if (!this.form.dateRange || this.form.dateRange.length !== 2) {
        return {
          disabledDate: function disabledDate() {
            return true;
          }
        };
      }
      var min = new Date(this.form.dateRange[0]);
      var max = new Date(this.form.dateRange[1]);
      min.setHours(0, 0, 0, 0);
      max.setHours(0, 0, 0, 0);
      return {
        disabledDate: function disabledDate(date) {
          return date < min || date > max;
        }
      };
    },
    rangeCalendarCells: function rangeCalendarCells() {
      if (!this.rangeItems.length) return [];
      var cells = [];
      var leadingEmpty = this.getMondayFirstOffset(this.rangeItems[0].expireDate);
      for (var i = 0; i < leadingEmpty; i++) {
        cells.push({
          type: 'empty',
          key: "empty-start-".concat(i)
        });
      }
      this.rangeItems.forEach(function (item) {
        cells.push(_objectSpread({
          type: 'item',
          key: item.expireDate
        }, item));
      });
      var trailingEmpty = (7 - cells.length % 7) % 7;
      for (var _i = 0; _i < trailingEmpty; _i++) {
        cells.push({
          type: 'empty',
          key: "empty-end-".concat(_i)
        });
      }
      return cells;
    },
    calendarTitle: function calendarTitle() {
      var d = new Date(this.currentDate);
      if (Number.isNaN(d.getTime())) return '';
      return "".concat(d.getFullYear(), " \u5E74 ").concat(d.getMonth() + 1, " \u6708");
    }
  },
  watch: {
    storeId: function storeId(newStoreId, oldStoreId) {
      if (newStoreId && newStoreId !== oldStoreId && this.mode === 'hotel' && Number(this.form.syncStoreRefundConfig) === 1) {
        this.handleSyncStoreRefundConfigChange(1);
      }
    },
    mode: function mode(val) {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2.$refs.formRef) {
          _this2.$refs.formRef.clearValidate();
        }
      });
      if (val === 'hotel' && Number(this.form.syncStoreRefundConfig) === 1) {
        if (!this.form.hotelRefundConfigs || this.form.hotelRefundConfigs.length === 0) {
          this.initHotelRefundConfigs();
        }
      }
    },
    'form.dateRange': function formDateRange(val) {
      // 如果是初始化阶段，不触发同步（在 setFormData 中已处理）
      if (this.isInitializing) {
        return;
      }
      if (val && val.length === 2) {
        // 当日期范围变化时，将日历切换到开始日期所在的月份
        var startDate = new Date(val[0]);
        this.currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        this.syncAttrValueWithRange();
        this.syncEditablePrices();
      }
    },
    'form.price': function formPrice() {
      if (!this.isInitializing) {
        this.syncAttrValueWithRange({
          forcePrice: true
        });
        this.syncEditablePrices();
      }
    },
    'form.costPrice': function formCostPrice() {
      if (!this.isInitializing) {
        this.syncAttrValueWithRange({
          forceCostPrice: true
        });
        this.syncEditablePrices();
      }
    },
    'form.stock': function formStock() {
      if (!this.isInitializing) {
        this.syncAttrValueWithRange({
          forceStock: true
        });
        this.syncEditablePrices();
      }
    },
    stockWarning: function stockWarning() {
      if (!this.isInitializing) {
        this.syncAttrValueStockWarning();
      }
    },
    'form.minQuantity': function formMinQuantity() {
      if (!this.isInitializing) {
        this.syncAttrValueQuantity();
        if (this.$refs.formRef) {
          this.$refs.formRef.validateField('maxQuantity');
        }
      }
    },
    'form.maxQuantity': function formMaxQuantity() {
      if (!this.isInitializing) {
        this.syncAttrValueQuantity();
      }
    }
  },
  mounted: function mounted() {
    // 初始化时如果 mode 已经是 hotel，确保数据已填充
    if (this.mode === 'hotel' && Number(this.form.syncStoreRefundConfig) === 1) {
      if (!this.form.hotelRefundConfigs || this.form.hotelRefundConfigs.length === 0) {
        this.initHotelRefundConfigs();
      }
      if (this.storeId && Number(this.form.syncStoreRefundConfig) === 1) {
        this.handleSyncStoreRefundConfigChange(1);
      }
    }
  },
  methods: {
    normalizeMinQuantity: function normalizeMinQuantity() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.form.minQuantity;
      if (value === '' || value === null || value === undefined || isNaN(Number(value)) || Number(value) < 1) {
        return 1;
      }
      return Number(value);
    },
    normalizeMaxQuantity: function normalizeMaxQuantity() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.form.maxQuantity;
      if (value === '' || value === null || value === undefined || isNaN(Number(value)) || Number(value) < 1) {
        return 9999;
      }
      return Number(value);
    },
    normalizeStockWarning: function normalizeStockWarning() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.localStockWarning;
      if (value === '' || value === null || value === undefined || isNaN(Number(value))) {
        return 0;
      }
      return Number(value);
    },
    syncAttrValueStockWarning: function syncAttrValueStockWarning() {
      var _this3 = this;
      var stockWarning = this.normalizeStockWarning();
      this.form.attrValue.forEach(function (item, index) {
        _this3.$set(_this3.form.attrValue[index], 'stockWarning', stockWarning);
      });
    },
    syncAttrValueQuantity: function syncAttrValueQuantity() {
      var _this4 = this;
      var minQuantity = this.normalizeMinQuantity();
      var maxQuantity = this.normalizeMaxQuantity();
      this.form.attrValue.forEach(function (item, index) {
        _this4.$set(_this4.form.attrValue[index], 'minQuantity', minQuantity);
        _this4.$set(_this4.form.attrValue[index], 'maxQuantity', maxQuantity);
      });
    },
    handleCustomerCancelDaysInput: function handleCustomerCancelDaysInput(value) {
      var nextValue = String(value === undefined || value === null ? '' : value).replace(/[^\d]/g, '');
      this.form.customerCancelDays = nextValue;
    },
    handleCustomerCancelTimeChange: function handleCustomerCancelTimeChange() {
      if (this.$refs.formRef) {
        this.$refs.formRef.validateField('customerCancelDays');
      }
    },
    handleRefundTimeChange: function handleRefundTimeChange() {
      if (this.$refs.formRef) {
        this.$refs.formRef.validateField('refundDays');
      }
    },
    // ==================== 酒店退款配置 ====================
    // 初始化酒店退款配置
    initHotelRefundConfigs: function initHotelRefundConfigs() {
      this.form.hotelRefundConfigs = this.defaultHotelRefundConfigs.map(function (item) {
        return _objectSpread({}, item);
      });
      this.syncHotelRefundConfigRanges();
    },
    // 恢复新增商品时的默认退款规则。
    handleResetHotelRefundConfigs: function handleResetHotelRefundConfigs() {
      this.initHotelRefundConfigs();
      this.handleHotelRefundConfigManualChange();
    },
    // 最后一档起始小时变化后重新同步区间和不可取消边界。
    handleRefundStartHourChange: function handleRefundStartHourChange(index, val) {
      this.syncHotelRefundConfigRanges();
      this.handleHotelRefundConfigManualChange();
    },
    // 商品退款规则被人工修改后，不再视为与店铺配置同步。
    handleHotelRefundConfigManualChange: function handleHotelRefundConfigManualChange() {
      if (!this.isInitializing && Number(this.form.syncStoreRefundConfig) === 1) {
        this.$set(this.form, 'syncStoreRefundConfig', 0);
      }
    },
    // 新增一行退款配置：仅在最后一项后追加，确保时间范围连续且不重叠
    handleAddRefundRow: function handleAddRefundRow() {
      var list = this.form.hotelRefundConfigs || [];
      if (list.length >= 11) {
        this.$message.warning('最多新增10项');
        return;
      }
      if (list.length === 0) {
        list.push({
          startHour: 96,
          endHour: null,
          refundRate: 100,
          disabled: true
        });
        this.syncHotelRefundConfigRanges();
        this.handleHotelRefundConfigManualChange();
        return;
      }
      var lastItem = list[list.length - 1];
      var newEndHour = Number(lastItem.startHour);
      if (!Number.isInteger(newEndHour) || newEndHour <= 1) {
        this.$message.warning('当前时间边界无法继续新增');
        return;
      }
      list.push({
        startHour: Math.max(1, newEndHour - 24),
        endHour: newEndHour,
        refundRate: Number(lastItem.refundRate) || 1,
        disabled: false
      });
      this.syncHotelRefundConfigRanges();
      this.handleHotelRefundConfigManualChange();
    },
    // 删除一行退款配置
    handleRemoveRefundRow: function handleRemoveRefundRow(index) {
      var list = this.form.hotelRefundConfigs;
      if (list.length <= 1) {
        this.$message.warning('至少保留首项退款配置');
        return;
      }
      if (index !== list.length - 2) {
        return;
      }
      list.splice(index + 1, 1);
      this.syncHotelRefundConfigRanges();
      this.handleHotelRefundConfigManualChange();
    },
    // 同步店铺配置时读取店铺规则；不同步时清空，等待商品自行配置。
    handleSyncStoreRefundConfigChange: function () {
      var _handleSyncStoreRefundConfigChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
        var requestVersion, configs, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              requestVersion = ++this.refundConfigVersion;
              if (!(Number(value) === 0)) {
                _context.n = 1;
                break;
              }
              this.form.hotelRefundConfigs = [];
              this.form.cancelLimitHour = null;
              return _context.a(2);
            case 1:
              if (this.storeId) {
                _context.n = 2;
                break;
              }
              this.$message.warning('请先选择店铺');
              this.form.syncStoreRefundConfig = 0;
              return _context.a(2);
            case 2:
              _context.p = 2;
              _context.n = 3;
              return (0, _rsManagement.getStoreHotelRefundConfigs)(this.storeId);
            case 3:
              configs = _context.v;
              if (!(requestVersion !== this.refundConfigVersion || Number(this.form.syncStoreRefundConfig) !== 1)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              if (!(!Array.isArray(configs) || configs.length === 0)) {
                _context.n = 5;
                break;
              }
              this.$message.warning('该店铺未配置酒店退款规则');
              this.form.syncStoreRefundConfig = 0;
              this.form.hotelRefundConfigs = [];
              return _context.a(2);
            case 5:
              this.form.hotelRefundConfigs = configs.map(function (item) {
                return _objectSpread({}, item);
              });
              this.syncHotelRefundConfigRanges();
              _context.n = 8;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              if (!(requestVersion !== this.refundConfigVersion)) {
                _context.n = 7;
                break;
              }
              return _context.a(2);
            case 7:
              this.form.syncStoreRefundConfig = 0;
              this.$message.error('获取店铺退款配置失败');
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[2, 6]]);
      }));
      function handleSyncStoreRefundConfigChange(_x) {
        return _handleSyncStoreRefundConfigChange.apply(this, arguments);
      }
      return handleSyncStoreRefundConfigChange;
    }(),
    // 统一衔接各退款区间，并让不可取消时间始终取最后一项起始小时。
    syncHotelRefundConfigRanges: function syncHotelRefundConfigRanges() {
      var list = this.form.hotelRefundConfigs || [];
      if (!list.length) return;
      this.$set(list[0], 'endHour', null);
      for (var i = 1; i < list.length; i++) {
        var previousStartHour = list[i - 1].startHour;
        var hasPreviousStartHour = previousStartHour !== null && previousStartHour !== '' && Number.isInteger(Number(previousStartHour)) && Number(previousStartHour) > 0;
        this.$set(list[i], 'endHour', hasPreviousStartHour ? Number(previousStartHour) : null);
      }
      var lastItem = list[list.length - 1];
      var lastStartHour = lastItem && lastItem.startHour;
      this.form.cancelLimitHour = lastStartHour !== null && lastStartHour !== '' && Number.isInteger(Number(lastStartHour)) && Number(lastStartHour) > 0 ? Number(lastStartHour) : null;
    },
    // 酒店退款规则属于酒店商品的必填配置，提交前校验完整性。
    validateHotelRefundConfigs: function validateHotelRefundConfigs() {
      var list = this.form.hotelRefundConfigs;
      var invalid = !Array.isArray(list) || list.length === 0 || list.some(function (item, index) {
        var startHour = Number(item.startHour);
        var endHour = index === 0 ? null : Number(item.endHour);
        var refundRate = Number(item.refundRate);
        var hasStartHour = item.startHour !== null && item.startHour !== '' && Number.isInteger(startHour) && startHour > 0;
        var hasEndHour = index === 0 || item.endHour !== null && item.endHour !== '' && Number.isInteger(endHour);
        var continuous = index === 0 || endHour === Number(list[index - 1].startHour) && startHour < endHour;
        return !hasStartHour || !hasEndHour || !continuous || index === 0 && refundRate !== 100 || !Number.isFinite(refundRate) || refundRate <= 0 || refundRate > 100;
      });
      if (invalid) {
        this.$message.error('请完整填写取消订单商品退款配置');
        return false;
      }
      return true;
    },
    // ==================== /酒店退款配置 ====================
    // 打开范围变价弹窗
    rangePrice: function rangePrice() {
      this.syncAttrValueWithRange();
      this.syncEditablePrices();
      this.rangeForm = {
        dateRange: [],
        basePrice: this.form.price || '',
        baseCostPrice: this.form.costPrice || '',
        baseStock: this.form.stock !== undefined && this.form.stock !== null ? String(this.form.stock) : ''
      };
      this.rangeItems = [];
      this.rangeDialogVisible = true;
    },
    goPrevMonth: function goPrevMonth() {
      var d = new Date(this.currentDate);
      d.setDate(1);
      d.setMonth(d.getMonth() - 1);
      this.currentDate = d;
    },
    goToday: function goToday() {
      this.currentDate = new Date();
    },
    goNextMonth: function goNextMonth() {
      var d = new Date(this.currentDate);
      d.setDate(1);
      d.setMonth(d.getMonth() + 1);
      this.currentDate = d;
    },
    // 范围选择变化时，预填周价格
    onRangeDateChange: function onRangeDateChange() {
      var _this5 = this;
      var dateRange = this.rangeForm.dateRange;
      if (!dateRange || dateRange.length !== 2) {
        this.rangeItems = [];
        return;
      }
      var _dateRange = _slicedToArray(dateRange, 2),
        start = _dateRange[0],
        end = _dateRange[1];
      var dates = this.getDatesInRange(start, end);
      var items = [];
      dates.forEach(function (dateStr) {
        var idx = _this5.form.attrValue.findIndex(function (item) {
          return item.expireDate === dateStr;
        });
        if (idx === -1) {
          var payload = {
            stock: _this5.form.stock || 0,
            price: _this5.form.price || 0,
            costPrice: _this5.form.costPrice || _this5.form.price || 0,
            expireDate: dateStr,
            // skuCode: `SKU${dateStr.replace(/-/g, '')}${Math.floor(1000 + Math.random() * 9000)}`,
            weekDay: _this5.getWeekday(dateStr),
            status: 1,
            checked: 0,
            stockWarning: _this5.normalizeStockWarning(),
            minQuantity: _this5.normalizeMinQuantity(),
            maxQuantity: _this5.normalizeMaxQuantity()
          };
          _this5.form.attrValue.push(payload);
          idx = _this5.form.attrValue.length - 1;
        }
        items.push({
          idx: idx,
          expireDate: _this5.form.attrValue[idx].expireDate,
          weekDay: _this5.form.attrValue[idx].weekDay
        });
      });
      this.rangeItems = items;
      this.syncEditablePrices();
    },
    // 将基础价格应用到当前范围
    applyBasePriceToRange: function applyBasePriceToRange() {
      var _this6 = this;
      var price = this.rangeForm.basePrice;
      if (price === '' || price === null || isNaN(Number(price))) {
        this.$message.error('请输入有效的价格');
        return;
      }
      this.rangeItems.forEach(function (item) {
        _this6.$set(_this6.form.attrValue[item.idx], 'price', price);
      });
      this.syncEditablePrices();
      this.$message.success('已应用到所有日期');
    },
    // 将基础价格应用到周末（周六和周日）
    applyBasePriceToWeekend: function applyBasePriceToWeekend() {
      var _this7 = this;
      var price = this.rangeForm.basePrice;
      if (price === '' || price === null || isNaN(Number(price))) {
        this.$message.error('请输入有效的价格');
        return;
      }
      // 筛选出周六和周日
      var weekendItems = this.rangeItems.filter(function (item) {
        return item.weekDay === '周六' || item.weekDay === '周日';
      });
      if (weekendItems.length === 0) {
        this.$message.warning('当前范围内没有周末日期');
        return;
      }
      // 只应用到周末日期
      weekendItems.forEach(function (item) {
        _this7.$set(_this7.form.attrValue[item.idx], 'price', price);
      });
      this.syncEditablePrices();
      this.$message.success("\u5DF2\u5E94\u7528\u5230 ".concat(weekendItems.length, " \u4E2A\u5468\u672B\u65E5\u671F"));
    },
    // 将基础成本价应用到当前范围
    applyBaseCostPriceToRange: function applyBaseCostPriceToRange() {
      var _this8 = this;
      var costPrice = this.rangeForm.baseCostPrice;
      if (costPrice === '' || costPrice === null || isNaN(Number(costPrice))) {
        this.$message.error('请输入有效的成本价');
        return;
      }
      var invalidItem = this.rangeItems.find(function (item) {
        var currentItem = _this8.form.attrValue[item.idx];
        return !_this8.validateCostPriceNotGreaterThanPrice(currentItem && currentItem.price, costPrice, '', false);
      });
      if (invalidItem) {
        this.$message.error("".concat(invalidItem.expireDate, " \u6210\u672C\u4EF7\u4E0D\u80FD\u5927\u4E8E\u5355\u4EF7"));
        return;
      }
      this.rangeItems.forEach(function (item) {
        _this8.$set(_this8.form.attrValue[item.idx], 'costPrice', costPrice);
      });
      this.syncEditablePrices();
      this.$message.success('成本价已应用到所有日期');
    },
    // 将基础成本价应用到周末（周六和周日）
    applyBaseCostPriceToWeekend: function applyBaseCostPriceToWeekend() {
      var _this9 = this;
      var costPrice = this.rangeForm.baseCostPrice;
      if (costPrice === '' || costPrice === null || isNaN(Number(costPrice))) {
        this.$message.error('请输入有效的成本价');
        return;
      }
      var weekendItems = this.rangeItems.filter(function (item) {
        return item.weekDay === '周六' || item.weekDay === '周日';
      });
      if (weekendItems.length === 0) {
        this.$message.warning('当前范围内没有周末日期');
        return;
      }
      var invalidItem = weekendItems.find(function (item) {
        var currentItem = _this9.form.attrValue[item.idx];
        return !_this9.validateCostPriceNotGreaterThanPrice(currentItem && currentItem.price, costPrice, '', false);
      });
      if (invalidItem) {
        this.$message.error("".concat(invalidItem.expireDate, " \u6210\u672C\u4EF7\u4E0D\u80FD\u5927\u4E8E\u5355\u4EF7"));
        return;
      }
      weekendItems.forEach(function (item) {
        _this9.$set(_this9.form.attrValue[item.idx], 'costPrice', costPrice);
      });
      this.syncEditablePrices();
      this.$message.success("\u6210\u672C\u4EF7\u5DF2\u5E94\u7528\u5230 ".concat(weekendItems.length, " \u4E2A\u5468\u672B\u65E5\u671F"));
    },
    // 将基础库存应用到当前范围（团购预约）
    applyBaseStockToRange: function applyBaseStockToRange() {
      var _this0 = this;
      var stock = this.rangeForm.baseStock;
      if (stock === '' || stock === null || isNaN(Number(stock)) || !/^\d+$/.test(String(stock))) {
        this.$message.error('请输入有效的库存');
        return;
      }
      this.rangeItems.forEach(function (item) {
        _this0.$set(_this0.form.attrValue[item.idx], 'stock', Number(stock));
      });
      this.$message.success('库存已应用到所有日期');
    },
    // 将基础库存应用到周末（团购预约）
    applyBaseStockToWeekend: function applyBaseStockToWeekend() {
      var _this1 = this;
      var stock = this.rangeForm.baseStock;
      if (stock === '' || stock === null || isNaN(Number(stock)) || !/^\d+$/.test(String(stock))) {
        this.$message.error('请输入有效的库存');
        return;
      }
      var weekendItems = this.rangeItems.filter(function (item) {
        return item.weekDay === '周六' || item.weekDay === '周日';
      });
      if (weekendItems.length === 0) {
        this.$message.warning('当前范围内没有周末日期');
        return;
      }
      weekendItems.forEach(function (item) {
        _this1.$set(_this1.form.attrValue[item.idx], 'stock', Number(stock));
      });
      this.$message.success("\u5E93\u5B58\u5DF2\u5E94\u7528\u5230 ".concat(weekendItems.length, " \u4E2A\u5468\u672B\u65E5\u671F"));
    },
    // 同步可编辑价格
    syncEditablePrices: function syncEditablePrices() {
      this.editablePrices = this.form.attrValue.reduce(function (acc, cur) {
        acc[cur.expireDate] = cur.price;
        return acc;
      }, {});
      this.editableCostPrices = this.form.attrValue.reduce(function (acc, cur) {
        acc[cur.expireDate] = cur.costPrice !== undefined && cur.costPrice !== null ? cur.costPrice : cur.price;
        return acc;
      }, {});
    },
    // 同步 attrValue 与日期范围
    syncAttrValueWithRange: function syncAttrValueWithRange() {
      var _this10 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$forcePrice = options.forcePrice,
        forcePrice = _options$forcePrice === void 0 ? false : _options$forcePrice,
        _options$forceCostPri = options.forceCostPrice,
        forceCostPrice = _options$forceCostPri === void 0 ? false : _options$forceCostPri,
        _options$forceStock = options.forceStock,
        forceStock = _options$forceStock === void 0 ? false : _options$forceStock;
      if (!this.form.dateRange || this.form.dateRange.length !== 2) {
        this.form.attrValue = [];
        this.editablePrices = {};
        this.editableCostPrices = {};
        return;
      }
      var _this$form$dateRange2 = _slicedToArray(this.form.dateRange, 2),
        start = _this$form$dateRange2[0],
        end = _this$form$dateRange2[1];
      var dates = this.getDatesInRange(start, end);
      var priceMap = {};
      var costPriceMap = {};
      var stockMap = {};
      var existingAttrValueMap = {};
      this.form.attrValue.forEach(function (item) {
        existingAttrValueMap[item.expireDate] = item;
      });
      if (!forcePrice || !forceCostPrice || !forceStock) {
        this.form.attrValue.forEach(function (item) {
          if (!forcePrice) {
            priceMap[item.expireDate] = item.price;
          }
          if (!forceCostPrice) {
            costPriceMap[item.expireDate] = item.costPrice !== undefined && item.costPrice !== null ? item.costPrice : item.price;
          }
          if (!forceStock) {
            stockMap[item.expireDate] = item.stock;
          }
        });
      }
      this.form.attrValue = dates.map(function (dateStr) {
        var existingAttrValue = existingAttrValueMap[dateStr] || {};
        return _objectSpread(_objectSpread({}, existingAttrValue), {}, {
          stock: forceStock ? _this10.form.stock || 0 : stockMap[dateStr] !== undefined ? stockMap[dateStr] : _this10.form.stock || 0,
          price: forcePrice ? _this10.form.price || 0 : priceMap[dateStr] !== undefined ? priceMap[dateStr] : _this10.form.price || 0,
          costPrice: forceCostPrice ? _this10.form.costPrice || _this10.form.price || 0 : costPriceMap[dateStr] !== undefined ? costPriceMap[dateStr] : _this10.form.costPrice || _this10.form.price || 0,
          expireDate: dateStr,
          weekDay: _this10.getWeekday(dateStr),
          status: 1,
          checked: 0,
          stockWarning: _this10.normalizeStockWarning(),
          minQuantity: _this10.normalizeMinQuantity(),
          maxQuantity: _this10.normalizeMaxQuantity()
        });
      });
    },
    // 获取范围内的所有日期（包含起止）
    getDatesInRange: function getDatesInRange(startStr, endStr) {
      var start = new Date(startStr);
      var end = new Date(endStr);
      var res = [];
      var cur = new Date(start);
      while (cur <= end) {
        var y = cur.getFullYear();
        var m = String(cur.getMonth() + 1).padStart(2, '0');
        var d = String(cur.getDate()).padStart(2, '0');
        res.push("".concat(y, "-").concat(m, "-").concat(d));
        cur.setDate(cur.getDate() + 1);
      }
      return res;
    },
    // 返回周几文本
    getWeekday: function getWeekday(dateStr) {
      var weekdayMap = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      var d = new Date(dateStr);
      return weekdayMap[d.getDay()] || '';
    },
    // 以周一为一周起始，计算日期在日历行中的列偏移
    getMondayFirstOffset: function getMondayFirstOffset(dateStr) {
      var d = new Date(dateStr);
      var day = d.getDay();
      return day === 0 ? 6 : day - 1;
    },
    // 判断日期是否在范围内
    isDateInRange: function isDateInRange(dateStr) {
      if (!this.form.dateRange || this.form.dateRange.length !== 2) {
        return false;
      }
      var date = new Date(dateStr);
      var startDate = new Date(this.form.dateRange[0]);
      var endDate = new Date(this.form.dateRange[1]);
      return date >= startDate && date <= endDate;
    },
    getCalendarDayClass: function getCalendarDayClass(dateStr) {
      if (!this.isDateInRange(dateStr)) {
        return 'is-disabled';
      }
      var weekday = this.getWeekday(dateStr);
      return {
        'is-active': true,
        'is-weekend': weekday === '周六' || weekday === '周日',
        'is-clickable': true
      };
    },
    formatDisplayPrice: function formatDisplayPrice(price) {
      if (price === '' || price === null || price === undefined) return '0.00';
      var num = Number(price);
      return Number.isNaN(num) ? '0.00' : num.toFixed(2);
    },
    getDateStock: function getDateStock(dateStr) {
      var found = this.form.attrValue.find(function (item) {
        return item.expireDate === dateStr;
      });
      if (found) {
        return found.stock !== undefined && found.stock !== null ? found.stock : 0;
      }
      return this.form.stock || 0;
    },
    handleDayClick: function handleDayClick(dateStr) {
      if (!this.isDateInRange(dateStr)) {
        return;
      }
      this.openDayEditDialog(dateStr);
    },
    openDayEditDialog: function openDayEditDialog(dateStr) {
      var _this11 = this;
      var idx = this.form.attrValue.findIndex(function (item) {
        return item.expireDate === dateStr;
      });
      if (idx === -1) {
        return;
      }
      var item = this.form.attrValue[idx];
      this.dayForm = {
        idx: idx,
        expireDate: item.expireDate,
        weekDay: item.weekDay || item.weekday || this.getWeekday(dateStr),
        price: item.price !== undefined && item.price !== null ? String(item.price) : '',
        costPrice: item.costPrice !== undefined && item.costPrice !== null ? String(item.costPrice) : String(item.price || ''),
        stock: item.stock !== undefined && item.stock !== null ? String(item.stock) : ''
      };
      this.dayDialogVisible = true;
      this.$nextTick(function () {
        _this11.$refs.dayFormRef && _this11.$refs.dayFormRef.clearValidate();
      });
    },
    submitDayEdit: function submitDayEdit() {
      var _this12 = this;
      if (!this.$refs.dayFormRef) {
        return;
      }
      this.$refs.dayFormRef.validate(function (valid) {
        if (!valid) {
          return;
        }
        var _this12$dayForm = _this12.dayForm,
          idx = _this12$dayForm.idx,
          price = _this12$dayForm.price,
          costPrice = _this12$dayForm.costPrice,
          stock = _this12$dayForm.stock;
        if (idx === -1 || !_this12.form.attrValue[idx]) {
          return;
        }
        if (!_this12.validateCostPriceNotGreaterThanPrice(price, costPrice, "".concat(_this12.dayForm.expireDate, " \u6210\u672C\u4EF7\u4E0D\u80FD\u5927\u4E8E\u5355\u4EF7"))) {
          return;
        }
        _this12.$set(_this12.form.attrValue, idx, _objectSpread(_objectSpread({}, _this12.form.attrValue[idx]), {}, {
          price: price,
          costPrice: costPrice,
          stock: Number(stock)
        }));
        _this12.syncEditablePrices();
        _this12.dayDialogVisible = false;
        _this12.$message.success('已保存');
      });
    },
    resetDayForm: function resetDayForm() {
      this.dayForm = {
        idx: -1,
        expireDate: '',
        weekDay: '',
        price: '',
        costPrice: '',
        stock: ''
      };
      this.$refs.dayFormRef && this.$refs.dayFormRef.clearValidate();
    },
    // 获取日期对应的价格
    getDatePrice: function getDatePrice(dateStr) {
      var found = this.form.attrValue.find(function (item) {
        return item.expireDate === dateStr;
      });
      if (found) return found.price || '0.00';
      return '0.00';
    },
    // 获取日期对应的成本价
    getDateCostPrice: function getDateCostPrice(dateStr) {
      var found = this.form.attrValue.find(function (item) {
        return item.expireDate === dateStr;
      });
      if (found) return found.costPrice !== undefined && found.costPrice !== null ? found.costPrice : found.price || '0.00';
      return '0.00';
    },
    // 更新单个日期的价格（内联）
    onInlinePriceChange: function onInlinePriceChange(dateStr) {
      var value = this.editablePrices[dateStr];
      var idx = this.form.attrValue.findIndex(function (item) {
        return item.expireDate === dateStr;
      });
      if (idx !== -1) {
        this.$set(this.form.attrValue, idx, _objectSpread(_objectSpread({}, this.form.attrValue[idx]), {}, {
          price: value
        }));
      }
    },
    // 更新单个日期的成本价（内联）
    onInlineCostPriceChange: function onInlineCostPriceChange(dateStr) {
      var value = this.editableCostPrices[dateStr];
      var idx = this.form.attrValue.findIndex(function (item) {
        return item.expireDate === dateStr;
      });
      if (idx !== -1) {
        this.$set(this.form.attrValue, idx, _objectSpread(_objectSpread({}, this.form.attrValue[idx]), {}, {
          costPrice: value
        }));
      }
    },
    // 提交范围变价
    submitRangePrice: function submitRangePrice() {
      var _this13 = this;
      var dateRange = this.rangeForm.dateRange;
      if (!dateRange || dateRange.length !== 2) {
        this.$message.error('请选择日期范围');
        return;
      }
      if (!this.rangeItems.length) {
        this.$message.warning('当前范围内没有可编辑日期');
        return;
      }
      var rangeAttrValues = this.rangeItems.map(function (item) {
        return _this13.form.attrValue[item.idx];
      }).filter(Boolean);
      if (!this.validateAttrCostPriceList(rangeAttrValues)) {
        return;
      }
      this.syncEditablePrices();
      this.rangeDialogVisible = false;
    },
    // 获取表单数据
    getFormData: function getFormData() {
      var _this14 = this;
      var attrValue = this.form.attrValue.map(function (item) {
        var next = _objectSpread({}, item);
        next.weekDay = item.weekDay || item.weekday || _this14.getWeekday(item.expireDate);
        next.costPrice = item.costPrice !== undefined && item.costPrice !== null && item.costPrice !== '' ? item.costPrice : item.price;
        next.stockWarning = _this14.normalizeStockWarning();
        next.minQuantity = _this14.normalizeMinQuantity();
        next.maxQuantity = _this14.normalizeMaxQuantity();
        delete next.weekday;
        return next;
      });
      var hotelExtra = {
        dateRange: this.form.dateRange,
        price: this.form.price,
        costPrice: this.form.costPrice,
        stock: this.form.stock,
        minQuantity: this.normalizeMinQuantity(),
        maxQuantity: this.normalizeMaxQuantity()
      };
      if (this.mode === 'hotel') {
        hotelExtra.customerCancelDays = this.form.customerCancelDays;
        hotelExtra.customerCancelTime = this.form.customerCancelTime;
        hotelExtra.hotelRefundConfigs = this.form.hotelRefundConfigs.map(function (item) {
          return {
            startHour: Number(item.startHour),
            endHour: item.endHour == null ? null : Number(item.endHour),
            refundRate: Number(item.refundRate)
          };
        });
        hotelExtra.cancelLimitHour = Number(this.form.cancelLimitHour);
        hotelExtra.syncStoreRefundConfig = this.form.syncStoreRefundConfig;
      } else if (this.mode === 'appointment') {
        hotelExtra.refundDays = this.form.refundDays;
        hotelExtra.refundTime = this.form.refundTime;
        hotelExtra.timeoutAutoRefundFlag = this.form.timeoutAutoRefundFlag;
      }
      return {
        hotelCheckInTime: this.form.hotelCheckInTime,
        hotelCheckOutTime: this.form.hotelCheckOutTime,
        deadlineTime: this.form.deadlineTime,
        hotelExtra: hotelExtra,
        attrValue: attrValue
      };
    },
    //编辑模式下设置form的值
    setFormData: function setFormData(data) {
      var _this15 = this;
      if (!data) {
        console.warn('setFormData: 传入的数据为空');
        return;
      }

      // 设置初始化标志，避免触发 watch 导致价格被重置
      this.isInitializing = true;
      // 使挂载或店铺切换阶段尚未返回的店铺配置请求失效。
      this.refundConfigVersion++;

      // 提取 hotelExtra，确保安全展开
      var hotelExtra = data.hotelExtra || {};

      // 保留原有的 attrValue（如果有），避免被覆盖
      var existingAttrValue = (data.attrValue || hotelExtra.attrValue || []).map(function (item) {
        var next = _objectSpread({}, item);
        next.weekDay = item.weekDay || item.weekday || _this15.getWeekday(item.expireDate);
        next.costPrice = item.costPrice !== undefined && item.costPrice !== null && item.costPrice !== '' ? item.costPrice : item.price;
        delete next.weekday;
        return next;
      });
      var firstAttrValue = existingAttrValue.length ? existingAttrValue[0] : {};

      // 设置基本表单字段，hotelExtra 中的字段会覆盖 data 中的同名字段
      this.form = {
        hotelCheckInTime: data.hotelCheckInTime || '14:00',
        hotelCheckOutTime: data.hotelCheckOutTime || '12:00',
        deadlineTime: data.deadlineTime || hotelExtra.deadlineTime || '22:00',
        customerCancelDays: hotelExtra.customerCancelDays !== undefined && hotelExtra.customerCancelDays !== null ? String(hotelExtra.customerCancelDays) : '',
        customerCancelTime: hotelExtra.customerCancelTime || '22:00',
        refundDays: hotelExtra.refundDays !== undefined && hotelExtra.refundDays !== null ? String(hotelExtra.refundDays) : '',
        refundTime: hotelExtra.refundTime || '00:00',
        timeoutAutoRefundFlag: hotelExtra.timeoutAutoRefundFlag !== undefined && hotelExtra.timeoutAutoRefundFlag !== null ? Number(hotelExtra.timeoutAutoRefundFlag) : 1,
        dateRange: hotelExtra.dateRange || data.dateRange || null,
        price: hotelExtra.price !== undefined && hotelExtra.price !== null ? hotelExtra.price : data.price,
        costPrice: hotelExtra.costPrice !== undefined && hotelExtra.costPrice !== null ? hotelExtra.costPrice : data.costPrice !== undefined && data.costPrice !== null ? data.costPrice : data.price,
        stock: hotelExtra.stock !== undefined && hotelExtra.stock !== null ? hotelExtra.stock : data.stock,
        minQuantity: hotelExtra.minQuantity !== undefined && hotelExtra.minQuantity !== null ? hotelExtra.minQuantity : firstAttrValue.minQuantity !== undefined && firstAttrValue.minQuantity !== null ? firstAttrValue.minQuantity : 1,
        maxQuantity: hotelExtra.maxQuantity !== undefined && hotelExtra.maxQuantity !== null ? hotelExtra.maxQuantity : firstAttrValue.maxQuantity !== undefined && firstAttrValue.maxQuantity !== null ? firstAttrValue.maxQuantity : 9999,
        attrValue: existingAttrValue,
        // 酒店退款配置回显
        hotelRefundConfigs: function () {
          if (Array.isArray(hotelExtra.hotelRefundConfigs)) {
            return hotelExtra.hotelRefundConfigs.map(function (item) {
              return _objectSpread({}, item);
            });
          }
          return _this15.defaultHotelRefundConfigs.map(function (item) {
            return _objectSpread({}, item);
          });
        }(),
        cancelLimitHour: hotelExtra.cancelLimitHour || 24,
        syncStoreRefundConfig: hotelExtra.syncStoreRefundConfig !== undefined && hotelExtra.syncStoreRefundConfig !== null ? Number(hotelExtra.syncStoreRefundConfig) : hotelExtra.hotelRefundConfigs && hotelExtra.hotelRefundConfigs.length ? 0 : 1
      };
      this.syncHotelRefundConfigRanges();

      // 如果有日期范围，需要处理日历数据
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        // 如果有回显的 attrValue 数据，直接使用并同步到 editablePrices
        if (existingAttrValue && existingAttrValue.length > 0) {
          this.syncEditablePrices();
        } else {
          this.syncAttrValueWithRange();
          this.syncEditablePrices();
        }

        // 设置日历显示的月份为开始日期所在月份
        var startDate = new Date(this.form.dateRange[0]);
        this.currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
      } else {
        // 如果没有日期范围，清空 attrValue 和 editablePrices
        this.form.attrValue = [];
        this.editablePrices = {};
        this.editableCostPrices = {};
      }
      console.log('setFormData>>>>', this.form);
      // 初始化完成，重置标志位
      this.$nextTick(function () {
        _this15.isInitializing = false;
      });
    },
    // 表单验证
    validate: function validate() {
      var _this16 = this;
      return new Promise(function (resolve, reject) {
        if (!_this16.$refs.formRef) {
          reject(new Error('表单引用不存在'));
          return;
        }
        _this16.$refs.formRef.validate(function (valid) {
          if (valid) {
            if (_this16.mode === 'hotel' && !_this16.validateHotelRefundConfigs()) {
              reject(new Error('酒店退款配置校验失败'));
              return;
            }
            if (!_this16.validateCostPriceNotGreaterThanPrice(_this16.form.price, _this16.form.costPrice)) {
              reject(new Error('基础价格校验失败'));
              return;
            }
            // 额外验证：如果选择了日期范围，必须生成 attrValue
            if (_this16.form.dateRange && _this16.form.dateRange.length === 2) {
              if (!_this16.form.attrValue || _this16.form.attrValue.length === 0) {
                _this16.$message.error('请确保日期范围已正确生成价格数据');
                reject(new Error('日期范围数据未生成'));
                return;
              }
              var invalidCostPrice = _this16.form.attrValue.find(function (item) {
                return item.costPrice === '' || item.costPrice === null || item.costPrice === undefined || isNaN(Number(item.costPrice));
              });
              if (invalidCostPrice) {
                _this16.$message.error("".concat(invalidCostPrice.expireDate, " \u7684\u6210\u672C\u4EF7\u4E0D\u80FD\u4E3A\u7A7A\u4E14\u5FC5\u987B\u4E3A\u6709\u6548\u6570\u5B57"));
                reject(new Error('日期成本价不合法'));
                return;
              }
              if (!_this16.validateAttrCostPriceList(_this16.form.attrValue)) {
                reject(new Error('日期价格关系校验失败'));
                return;
              }
            }
            _this16.$emit('validate', _this16.form.attrValue);
            resolve(true);
          } else {
            _this16.$message.error('请完善表单必填项');
            reject(new Error('表单验证失败'));
          }
        });
      });
    },
    // 重置表单
    resetForm: function resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.form = {
        hotelCheckInTime: '14:00',
        hotelCheckOutTime: '12:00',
        deadlineTime: '22:00',
        customerCancelDays: '',
        customerCancelTime: '22:00',
        refundDays: '',
        refundTime: '00:00',
        timeoutAutoRefundFlag: 1,
        dateRange: null,
        price: '',
        costPrice: '',
        stock: '',
        minQuantity: 1,
        maxQuantity: 9999
      };
      this.form.attrValue = [];
      this.editablePrices = {};
      this.editableCostPrices = {};
    },
    validateCostPriceNotGreaterThanPrice: function validateCostPriceNotGreaterThanPrice(price, costPrice) {
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '成本价不能大于单价';
      var needMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (price === '' || price === null || price === undefined || costPrice === '' || costPrice === null || costPrice === undefined) {
        return true;
      }
      var priceNum = Number(price);
      var costPriceNum = Number(costPrice);
      if (Number.isNaN(priceNum) || Number.isNaN(costPriceNum)) {
        return true;
      }
      if (costPriceNum > priceNum) {
        if (needMessage) {
          this.$message.error(message);
        }
        return false;
      }
      return true;
    },
    validateAttrCostPriceList: function validateAttrCostPriceList() {
      var _this17 = this;
      var attrValueList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var invalidItem = attrValueList.find(function (item) {
        if (!item) return false;
        return !_this17.validateCostPriceNotGreaterThanPrice(item.price, item.costPrice, '', false);
      });
      if (invalidItem) {
        this.$message.error("".concat(invalidItem.expireDate, " \u6210\u672C\u4EF7\u4E0D\u80FD\u5927\u4E8E\u5355\u4EF7"));
        return false;
      }
      return true;
    }
  }
};